<template>
  <div class="footer"></div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.footer {
  background-image: url('~@/assets/img/footer.png');
  min-height: 80px;
  max-height: 80px;
  width: 100%;
  background-position: 66%;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  background-position-y: initial;
  bottom: 0;
  z-index: 2;
}
</style>
